import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const Negative = styled.span`
	color: red;
	font-weight: bold;
`;

const Neutral = styled.span`
	color: gray;
	font-weight: bold;
`;

const Positive = styled.span`
	color: green;
	font-weight: bold;
`;

interface PointsProps {
	value?: number;
}

const Points: FunctionComponent<PointsProps> = (props: PointsProps) => {
	const { value = 0 } = props;

	if (value < 0) {
		return <Negative>{value}</Negative>;
	} else if (value > 0) {
		return <Positive>{value}</Positive>;
	} else {
		return <Neutral>{value}</Neutral>;
	}
};

export default Points;
